

export const getCompositeProperty = (key, obj) => {
	const keyArr = key.split('.');
	let prop = obj;

	try {
		while(keyArr.length > 0) {
			prop = prop[keyArr.shift()];
		}
	} catch(err) {
		return '';
	}
	return prop;
};

export const setCompositeProperty = (obj, key, value) => {
	const keyArr = key.split('.');
	let prop = obj;

	keyArr.forEach((key, index) => {
		if(index + 1 == keyArr.length) {
			prop[key] = value;
			return;
		}

		if(prop[key] === undefined)
			prop[key] = {};
		prop = prop[key];
	});
};

export const mapValues = (object, valueProperty) => {
	return Object.keys(object)
	.reduce((mappedObject, objectKey) => {
		mappedObject[objectKey] = object[objectKey][valueProperty];
		return mappedObject;
	}, {});
};

export const filterKeys = (object, filterFunc) => {
	return Object.keys(object)
	.filter(filterFunc)
	.reduce((acc, k) => Object.assign(acc, { [k]: object[k] }), {});
};

export const removeKeys = (object, keysToRemove) => {
	return filterKeys(object, (k) => keysToRemove.indexOf(k) === -1);
};

export const getClassProperties = (clazz) => {
	var classProperties = [];
	while(clazz.prototype !== undefined) {
		const proto = clazz.prototype;
		clazz = Object.getPrototypeOf(clazz);
		classProperties = classProperties.concat(
			Object.getOwnPropertyNames(proto)
			.filter((p) => (
				typeof proto[p] !== 'function' &&
				classProperties.indexOf(p) === -1
			))
		);
	}

	return classProperties;
};

export const serializePrivateKeys = (obj) => {
	return Object.keys(obj).map(it => it.substring(1, it.length));
};

export const serializePrivateProperties = (obj) => {
	if(typeof obj !== 'object' || Array.isArray(obj)) return obj;
	const serializedObject = {};
	Object.keys(obj).forEach((k) => {
		let v = obj[k];
		if(!!v && typeof v == "object" && !Array.isArray(v)) {
			v = serializePrivateProperties(v);
		} else if(Array.isArray(v)) {
			v = v.map((i) => typeof i === 'object' ? serializePrivateProperties(i) : i);
		}

		serializedObject[k.replace(/^_/g, '')] = v;
	});

	return serializedObject;
};

export function getObjectKeyPath(path, pathActual) {
	var pathSplit = path ? path.split(/[.]/g) : [""];
	var pathDeleted = pathSplit.splice(0, 1);
	var cachePath = pathActual[pathDeleted[0]];

	if (typeof cachePath === 'undefined') {
		return "";
	} else if (!pathSplit.length) {
		return cachePath;
	}

	return getObjectKeyPath(pathSplit.join("."), cachePath);
}

export function convertToString (value) {
	let formatValue = value instanceof Array ? value[0] : value;

	if (formatValue === undefined || formatValue === null)
		return null;

	return String(formatValue);
}

export const ObjectUtils = {
	getCompositeProperty,
	getObjectKeyPath,
	setCompositeProperty,
	mapValues,
	filterKeys,
	removeKeys,
	getClassProperties,
	serializePrivateProperties,
	convertToString
};

export default ObjectUtils;
